module.exports = __webpack_public_path__ + "static/media/kmlsign.5ce9d4ae.svg";